export default __webpack_public_path__ + "static/media/profile.6ac6013a.svg";